import { ReactNode } from 'react';
import { Draggable } from '@hello-pangea/dnd';
import { GripVertical } from 'lucide-react';
import styles from './PunchupDraggableTile.module.css';

interface PunchupDraggableTileProps {
	/** Unique identifier passed to `Draggable draggableId`. */
	id: string;
	/** Position within the sortable list (0-based). */
	index: number;
	children: ReactNode;
}

const PunchupDraggableTile = ({ id, index, children }: PunchupDraggableTileProps) => (
	<Draggable draggableId={id} index={index}>
		{(provided, snapshot) => (
			<div
				ref={provided.innerRef}
				{...provided.draggableProps}
				className={`${styles.item}${snapshot.isDragging ? ` ${styles.isDragging}` : ''}`}
			>
				<div className={styles.handle} {...provided.dragHandleProps} aria-label="Drag to reorder">
					<GripVertical size={20} />
				</div>
				<div className={styles.content}>{children}</div>
			</div>
		)}
	</Draggable>
);

export { PunchupDraggableTile };
export type { PunchupDraggableTileProps };
